import { render } from "./api-reference.vue?vue&type=template&id=6115aecf&scoped=true"
import script from "./api-reference.vue?vue&type=script&lang=js"
export * from "./api-reference.vue?vue&type=script&lang=js"

import "./api-reference.vue?vue&type=style&index=0&id=6115aecf&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6115aecf"]])

export default __exports__